import Vue from "vue";
import postUserMixin from "@/v2/mixins/post-users.js";

Vue.component("bo-carousel", require("js/frontend/components/bo-carousel.vue").default);
Vue.component("bo-product-list", require("js/frontend/components/bo-product-list.vue").default);
Vue.component("bo-image-banner", require("js/frontend/components/bo-image-banner.vue").default);
Vue.component("bo-text-block", require("js/frontend/components/bo-text-block.vue").default);
Vue.component("bo-video-player", require("js/frontend/components/bo-video-player.vue").default);
Vue.component("bo-image-category-banner", require("js/frontend/components/bo-image-category-banner.vue").default);
Vue.component("bo-announcement", require("js/frontend/components/bo-announcement.vue").default);
Vue.component("bo-announcement-popup", require("js/frontend/components/bo-announcement-popup.vue").default);
Vue.component("bo-announcement-details", require("js/frontend/components/bo-announcement-details.vue").default);


const app = new Vue({
    el: "#app",
    mixins: [postUserMixin],
    data() {
        return {
            // Suppressed while the mandatory company selector is pending — company
            // selection takes priority over the first-login announcement.
            activeAnnouncement: !window.bo.companyNotSelected,
            featuredPosts: window.bo.featuredPosts,
            currentIndex: 0,
            userId: window.bo.userId,
            checkSession: true,
            isMobileViewport: window.isMobileViewport,
        };
    },
    mounted() {
        if (this.userId) {
            this.checkSession = true;
        } else {
            const stored = sessionStorage.getItem("checkSession");
            this.checkSession = stored ? JSON.parse(stored) : true;
        }
        window.addEventListener("resize", () => {
            this.isMobileViewport = window.isMobileViewport;
        });

        this.initCategoryCarousel();
    },
    computed: {
        posts() {
            return this.featuredPosts?.[0] ?? null;
        },
        currentContent() {
            return this.posts?.promptDetails?.[this.currentIndex] ?? null;
        },
    },
    watch: {
        activeAnnouncement(newVal, oldVal) {
            if (oldVal === true && newVal === false) {
                this.savePostBeforeNavigate();
            }
        }
    },
    methods: {
        // The category band is the one home section the app has no carousel component for, so it
        // is driven by slick - the same slider bo-carousel uses (and the SCSS already styles its
        // arrows). Scoped to the FFM homepage, so it is a no-op everywhere else.
        initCategoryCarousel() {
            const $section = jQuery(".familyfoodsmarketsdnbhd-home .bo-image-category-banner .category-section");

            if (!$section.length || $section.hasClass("slick-initialized")) {
                return;
            }

            $section.slick({
                slidesToShow: 5,
                slidesToScroll: 1,
                arrows: true,
                dots: false,
                // park the arrows in the heading row so they sit inline with the title
                appendArrows: ".familyfoodsmarketsdnbhd-home .bo-image-category-banner .banner-title",
                responsive: [
                    { breakpoint: 1200, settings: { slidesToShow: 4 } },
                    { breakpoint: 992, settings: { slidesToShow: 3 } },
                    { breakpoint: 768, settings: { slidesToShow: 2 } },
                ],
            });
        },
        redirectLocation(customer) {
            window.location.href = customer.url;
        },
        activateAnnouncement() {
            this.activeAnnouncement = true;
        },
        deactivateAnnouncement() {
            this.activeAnnouncement = false;
        },
        navigateDetailsPage() {
            this.savePostBeforeNavigate();
            const content = this.currentContent;

            if (!content) {
                window.location.href = this.posts.link;
                return;
            }

            window.location.href = `${this.posts.link}/${content.id}`;
        },
        savePostBeforeNavigate() {
            if (this.userId) {
                this.createPostUsers(
                    {
                        posts: this.posts?.promptDetails,
                        user_id: this.userId,
                    },
                    () => {},
                    null
                );
            } else {
                this.checkSession = false;
                sessionStorage.setItem("checkSession", JSON.stringify(this.checkSession));
            }
        },
        previousPage() {
            this.currentIndex--;
        },
        nextPage() {
            this.currentIndex++;
        },
    },
});
